import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import Heading from "components/heading"

const EditableDetailsSection = ({
  heading = "",
  details = []
}) => (
  <div>
    <Heading tag={"h2"} size={"medium"}>{heading}</Heading>
    {details.map(({ label, value }) => (
      <div key={label}>
        <div>{label}</div>
        <div>{value}</div>
      </div>
    )
    )}
  </div>
)

EditableDetailsSection.propTypes = {
  heading: PropTypes.string,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  )
}

export default Radium(EditableDetailsSection)



// WEBPACK FOOTER //
// ./src/components/mymazda/editable-details-section/index.jsx